module.exports = __webpack_public_path__ + "img/matias-selva-byn.f1d02274.jpg";